import React from 'react';

interface ProductOptionsFieldsProps {
  isActive: boolean;
  isNoPrize: boolean;
  onChange: (field: 'is_active' | 'is_no_prize', value: boolean) => void;
}

const checkboxBase =
  'rounded border-tinta/30 text-bordo focus:ring-bordo/40 focus:ring-offset-0 cursor-pointer';

const ProductOptionsFields: React.FC<ProductOptionsFieldsProps> = ({
  isActive,
  isNoPrize,
  onChange
}) => {
  return (
    <>
      <div className="col-span-2">
        <label className="flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => onChange('is_active', e.target.checked)}
            className={checkboxBase}
          />
          <span className="ml-2 text-sm font-bold text-tinta">Produto ativo</span>
        </label>
        <p className="mt-1 text-xs text-tinta-soft italic">
          Produtos inativos não aparecem nas roda de prêmios
        </p>
      </div>

      <div className="col-span-2">
        <label className="flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={isNoPrize}
            onChange={(e) => onChange('is_no_prize', e.target.checked)}
            className={checkboxBase}
          />
          <span className="ml-2 text-sm font-bold text-tinta">"Não foi dessa vez"</span>
        </label>
        <p className="mt-1 text-xs text-tinta-soft italic">
          Marque se este NÃO é um prêmio real. Ele nunca acaba no estoque e serve apenas para mostrar "tente de novo"
        </p>
      </div>
    </>
  );
};

export default ProductOptionsFields;
